/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_search = {};

(function(){
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function() {

		$('.js-searchbox-value').keypress(function(e) {

			var _new_value = $(this).val();

			if(e.which == 13) {

				$('.js-searchbox-value').val(_new_value);

				e.preventDefault();

				var _value = $('.js-searchbox-value').val();

				specific_search.search(_value);

			} else {

				$('.js-searchbox-value').val(_new_value);

			}

		});

		$('.js-searchbox-form').submit(function(e) {
		
			e.preventDefault();

			var _value = $('.js-searchbox-value').val();

			specific_search.search(_value);

		});

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	this.search = function(
		_value
	) {

		_value = _value.replace(/ /g, '+');

		_url = globalUrl + '/' + _language + '/search/' + _value;

		window.location.href = _url;

	};
		
}).apply(specific_search); 